import styleInject from '../../common/temp/pnpm_store/.pnpm/style-inject@0.3.0/pnpm_store/style-inject/dist/style-inject.es.js';

var css_248z = ".surface_editor-wrapper__39Ndg {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.surface_stack-view__3UVPj {\n  width: 100%;\n  height: 100%;\n  -webkit-user-select: text;\n     -moz-user-select: text;\n          user-select: text;\n  display: flex;\n}\n.surface_stack-view__3UVPj.surface_hide__36RO- {\n  display: none;\n}\n";
var styles = {"editor-wrapper":"surface_editor-wrapper__39Ndg","stack-view":"surface_stack-view__3UVPj","hide":"surface_hide__36RO-"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=surface.less.js.map
